import actionTypes from '../../constants/ActionTypes';
import { FETCH_STATUSES } from './constants';

type Action = { type: string; key: string; data: any; error: Error };

export default function(state = {}, action: Action) {
  switch (action.type) {
    case actionTypes.FETCH_IN_PROGRESS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          status: FETCH_STATUSES.IN_PROGRESS
        }
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          data: action.data,
          status: FETCH_STATUSES.SUCCESS
        }
      };
    case actionTypes.FETCH_FAILED:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          error: action.error,
          status: FETCH_STATUSES.FAILED
        }
      };
    default:
      return state;
  }
}
